"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.investorProfiles = exports.initialValuesConfig = exports.dropdownOptions = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'investor';
var investorProfiles = exports.investorProfiles = [{
  type: 'Short-Term',
  bondPct: '100%',
  stockPct: '0%',
  desc: 'For investors with short-term investment horizons who want to minimize the potential for loss of value, and who are looking for stability of assets.'
}, {
  type: 'Conservative',
  bondPct: '70%',
  stockPct: '30%',
  desc: 'For investors attempting to avoid a loss of assets in the short-term, with secondary objective of seeking a higher return over the long term to migrate the effects of inflation.'
}, {
  type: 'Moderate',
  bondPct: '50%',
  stockPct: '50%',
  desc: 'For investors who are equally concerned with balancing their level of risk and return.'
}, {
  type: 'Moderate Growth',
  bondPct: '30%',
  stockPct: '70%',
  desc: 'For investors with a longer time horizon. While their portfolio will typically have a higher-than-average volatility, it may provide for the potential of higher-than-average returns over the long term.'
}, {
  type: 'Growth',
  bondPct: '10%',
  stockPct: '90%',
  desc: 'For investors who are willing and able to stay the course through short-term volatility and want the potential for high portfolio returns over the long term.'
}];
var dropdownOptions = exports.dropdownOptions = {
  withdrawPlan: ['plan', 'do not plan'],
  riskTolerance: ['am ok with losing some of it', 'do not want to lose any of it'],
  retirementAge: ['62', '63', '64', '65', '66', '67', '68', '69', '70'],
  portfolioGoal: ['invest aggressively', 'invest with caution', 'avoid losing money'],
  longTermExpectation: ['make a big profit', 'earn a modest profit', 'at least break even'],
  performance3YearGoal: ['can live if I lose money', 'must at least break even', 'must make a small profit'],
  performance3MonthGoal: ['not worry about losses', 'worry about a 10% loss', 'worry about any loss'],
  lostJob: ['more than six months', 'three to six months', 'less than three months'],
  portfolioPercentage: ['a minor part', 'an important part', 'the vast majority']
};
var propsConfig = exports.propsConfig = {
  config: {
    Icon: 'icon-chart-line-black',
    Label: 'Investor Profile Quiz',
    HasBorder: true,
    Steps: [{
      Title: 'What kind of investor am I?',
      Description: '',
      SecondaryDescription: 'Your investment strategy should reflect the kind of investor you are. The following quiz is designed to suggest an investment strategy that may be right for your retirement savings based on your personal risk tolerance and financial situation.',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'What is the portfolio goal?',
      Description: '',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      }
    }, {
      Title: 'What is your risk tolerance?',
      Description: '',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Calculate',
        Icon: '',
        Variant: ''
      }
    }, {
      Title: 'Your Results',
      Description: '',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next Step',
        Description: 'Discuss your results with a financial professional today',
        CTAList: [{
          Label: 'Get Started',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: 'Compare policy types',
          Href: '',
          Target: '',
          Variant: 'link'
        }]
      }
    }]
  }
};
var validationConfigPage1 = yup.object().shape({
  withdrawPlan: yup.string().required('You must select a withdraw plan'),
  riskTolerance: yup.string().required('You must select a risk tolerance'),
  currentAge: yup.number('Current Age must be a number').required('You must provide a current age').test((info, meta) => {
    var ageLessThanOrEqualToRetirementAgeAnd65 = info <= meta.parent.retirementAge && info <= 65;
    var minOfRetirmentAgeAnd65 = Math.min(65, meta.parent.retirementAge);
    return ageLessThanOrEqualToRetirementAgeAnd65 ? true : meta.createError({
      path: "".concat(meta.path),
      message: "Must be at least 0 and at most ".concat(minOfRetirmentAgeAnd65, " years of age")
    });
  }),
  retirementAge: yup.number('Retirement Age must be a number').required('You must provide a current age').min(62, 'Must be greater or equal to 62').max(70, 'Must be less than or equal 70'),
  lifeExpectancy: yup.number('Life Expectency must be a number').required('You must provide a current age').test((info, meta) => {
    // must be greater than or equal to the max of 62 or retirementAge, must be less than or equal to 120
    var lifeExpectancyMaxCheck = info >= meta.parent.retirementAge;
    var lessThanOrEqualTo120 = info <= 120;
    return lifeExpectancyMaxCheck && lessThanOrEqualTo120 ? true : meta.createError({
      path: "".concat(meta.path),
      message: "Must be at least ".concat(meta.parent.retirementAge, " and at most 120 years of life expectancy")
    });
  })
});
var validationConfigPage2 = yup.object().shape({
  portfolioGoal: yup.string().required('You must select a portfolio goal'),
  longTermExpectation: yup.string().required('You must select a long term expectation'),
  performance3YearGoal: yup.string().required('You must select a 3 year perforamance goal')
});
var validationConfigPage3 = yup.object().shape({
  performance3MonthGoal: yup.string().required('You must select a 3 month perforamance goal'),
  lostJob: yup.string().required('You must select an option'),
  portfolioPercentage: yup.string().required('You must select an option')
});
var validationConfig = exports.validationConfig = [validationConfigPage1, validationConfigPage2, validationConfigPage3];
var initialValuesConfig = exports.initialValuesConfig = {
  withdrawPlan: '',
  riskTolerance: '',
  currentAge: '',
  retirementAge: '62',
  lifeExpectancy: '',
  portfolioGoal: '',
  longTermExpectation: '',
  performance3YearGoal: '',
  performance3MonthGoal: '',
  lostJob: '',
  portfolioPercentage: ''
};